import { render, staticRenderFns } from "./BIDisplayValue.vue?vue&type=template&id=23e8a0c6"
import script from "./BIDisplayValue.vue?vue&type=script&lang=js"
export * from "./BIDisplayValue.vue?vue&type=script&lang=js"
import style0 from "./BIDisplayValue.vue?vue&type=style&index=0&id=23e8a0c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports